import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import FileUpload from "../../../../parts/inputs/file-upload";
import ImageWidgetUploadInput from "../../../../parts/inputs/image-widget-upload";
import ThumbnailUploadInput from "../../../../parts/inputs/thumbnail-upload";
import _debounce from "lodash/debounce";
import submit from "submit-form";
import { S3 } from "../../../../constants";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import { whoIsAthleteCoach } from "../../../../utils/user-helpers";

const GeneralResources = ({
  locals,
  addingResource,
  setAddingResource,
  coachOrganizationInformation,
  setEditingResource,
  editingResource,
}) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const { athlete: athleteLocals } = locals;

  const [fileFormState, setFileFormState] = useState({
    file: "",
    name: "",
    description: "",
    image: "",
  });
  const [imageState, setImageState] = useState(null);
  const [fileState, setFileState] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [resources, setResources] = useState(athleteLocals?.guides?.resources);
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);

  useEffect(() => {
    if (!isDeleting) {
      if (athleteLocals?.guides?.resources) {
        const resources = athleteLocals?.guides?.resources;
        setResources(resources);
      } else {
        setResources([]);
      }
    }
  }, [athleteLocals, isDeleting]);

  useEffect(() => {
    if (addingResource === "none") {
      setFileFormState({
        file: "",
        name: "",
        description: "",
        image: "",
      });
      setLinkFormState({ url: "", name: "", description: "" });
      setImageState(null);
      setFileState(null);
      setEditingResource(null);
    }
  }, [addingResource]);

  const handleImageUpload = (newImage) => {
    setImageState(newImage);
  };

  const handleFileUpload = (newFile) => {
    setFileState(newFile);
  };

  /**
   * Validate if edit form is valid
   * @returns
   */
  const validationFileSubmit = () => {
    if (!editingResource) {
      if (
        fileFormState.name.length > 0 &&
        fileFormState.description.length > 0 &&
        imageState !== null &&
        fileState !== null
      ) {
        return true;
      }
      return false;
    } else {
      if (
        fileFormState.name.length > 0 &&
        fileFormState.description.length > 0
      ) {
        return true;
      }
      return false;
    }
  };

  /**
   * assign the value to the add new file state
   * @param {*} param0
   */
  const handleInputFileChange = ({ target }) => {
    const newState = Object.assign({}, fileFormState, {
      [target.name]: target.value,
    });
    setFileFormState(newState);
  };

  // LINKS

  const widgetLinkThumbnail = locals.widgetLinkThumbnail;
  const [linkFormState, setLinkFormState] = useState({
    url: "",
    name: "",
    description: "",
  });

  function handleDebounceFn(inputValue) {
    submit(`/actions/links/thumbnail`, {
      method: "POST",
      body: { url: inputValue },
    });
  }

  //memorize the debounce function to avoid recreate it again when the component rerenders
  const debounceFn = useCallback(_debounce(handleDebounceFn, 2000), []);

  /**
   * assign the value to the add new link state
   * @param {*} param0
   */
  const handleInputLinkChange = (event) => {
    const newState = Object.assign({}, linkFormState, {
      [event.target.name]: event.target.value,
    });
    setLinkFormState(newState);

    searchThumbnail(event);
  };

  /**
   * search thumbnail when user enter a url
   */
  const searchThumbnail = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const URL_REGEX =
      /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    if (!URL_REGEX.test(e.target.value)) {
      return;
    }

    debounceFn(e.target.value);
  };

  /**
   * Validate if edit form is valid
   * @returns
   */
  const validationLinkSubmit = () => {
    if (linkFormState.url.length > 0 && !!widgetLinkThumbnail) {
      return true;
    }
    return false;
  };

  const handleCancelDelete = () => {
    setOpenedConfirmationModal(false);
    setDeleteId(null);
  };

  const handleConfirmDelete = () => {
    setIsDeleting(true);

    let body = {
      athleteId: athleteLocals._id,
      type: "resources",
      id: deleteId,
    };
    if (coachOrganizationInformation) {
      const userToRequest =
        String(
          whoIsAthleteCoach(
            activeUser.athletes,
            athleteLocals._id,
            activeUser._id,
            coachOrganizationInformation._id
          )
        ) !== String(activeUser._id)
          ? coachOrganizationInformation._id
          : activeUser._id;

      body = {
        ...body,
        userToRequest,
      };
    }
    submit("/actions/guides/remove", {
      method: "POST",
      body,
    });

    const newResources = resources.filter(
      (resource) => resource.id !== deleteId
    );
    setResources(newResources);
    setOpenedConfirmationModal(false);
    setDeleteId(null);

    setTimeout(() => setIsEditing(false), 500);
  };

  const handleRemove = (e, id) => {
    e.preventDefault();
    setOpenedConfirmationModal(true);
    setDeleteId(id);
  };

  return (
    <div className="resources">
      <h4>{t("generalResources.title")}</h4>

      {addingResource === "none" && !!resources && resources.length > 0 && (
        <section>
          {resources.map(
            ({ id, file, image, type, name, description, url, thumbnail }) => {
              if (type === "pdf") {
                return (
                  <article key={`${id}-pdf`} id={id} className="resource-item">
                    <div className="column width-widget-information">
                      <div>
                        <input
                          className="file-section-div"
                          name="file"
                          style={{ display: "none" }}
                          readOnly
                          value={JSON.stringify(file)}
                        />
                        <input
                          className="image-section-div"
                          name="image"
                          style={{ display: "none" }}
                          readOnly
                          value={JSON.stringify(image)}
                        />
                        <input
                          className="id-section-div"
                          name="id"
                          style={{ display: "none" }}
                          readOnly
                          value={id}
                        />
                        <img src={S3.toCDN(image.s3Path)} loading="lazy" />
                      </div>
                      <div>
                        <p className="s2">{name}</p>
                        <p className="p4">{description}</p>
                      </div>
                    </div>
                    <div className="action-buttons">
                      <button data-button-type="secondary" data-icon-only>
                        <SvgIcon
                          src="/img/new-icons/edit-pencil.svg"
                          onClickFn={(e) => {
                            e.preventDefault();
                            setFileFormState({
                              name: name,
                              description: description,
                              file: file,
                              image: image,
                            });
                            setEditingResource(id);
                            setAddingResource("pdf");
                          }}
                        />
                      </button>
                      <button data-button-type="secondary" data-icon-only>
                        <SvgIcon
                          src={"/img/new-icons/red-trash.svg"}
                          onClickFn={(event) => handleRemove(event, id)}
                          noFilterOnLight={true}
                        />
                      </button>
                    </div>
                  </article>
                );
              } else if (type === "url") {
                const imageToShow =
                  image && Object.keys(image).length > 0 ? image : undefined;

                return (
                  <article
                    key={`${id}-url`}
                    id={id}
                    className="resource-item link"
                  >
                    <div
                      className={
                        image
                          ? "link-image-thumbnail-section"
                          : "link-image-no-thumbnail-section"
                      }
                    >
                      <input
                        className="id-section-div"
                        name="id"
                        style={{ display: "none" }}
                        readOnly
                        value={id}
                      />
                      {/* if have thumbnail but no image */}
                      {thumbnail ? (
                        <img
                          className="thumbnail-section-div"
                          src={thumbnail}
                          loading="lazy"
                        />
                      ) : // if dont have thumbnail and have image
                      !thumbnail && imageToShow ? (
                        <div>
                          <img src={S3.toCDN(image.s3Path)} loading="lazy" />
                          <input
                            className="image-section-div"
                            name="image"
                            style={{ display: "none" }}
                            readOnly
                            value={JSON.stringify(image)}
                          />
                        </div>
                      ) : // if  have thumbnail and have image
                      thumbnail && imageToShow ? (
                        <div>
                          <img src={S3.toCDN(image.s3Path)} loading="lazy" />
                          <input
                            className="image-section-div"
                            name="image"
                            style={{ display: "none" }}
                            readOnly
                            value={JSON.stringify(image)}
                          />
                        </div>
                      ) : (
                        // if dont have thumbnail and dont have image
                        <div className="thumbnail-image-div">
                          <p className="p4">{t("generalResources.thumbnailNotAvailable")}</p>
                        </div>
                      )}

                      <div className="flex flex-col gap-1">
                        <p className="s2">{name}</p>
                        <p className="p4 opacity-70">{description}</p>
                        <a
                          className="mt-1 text-sky-600"
                          target="_blank"
                          rel="noopener"
                          href={url}
                        >
                          {url}
                        </a>
                      </div>
                    </div>

                    <div className="action-buttons">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setLinkFormState({
                            url: url,
                            thumbnail: thumbnail,
                            image: image,
                            name: name,
                            description: description,
                          });
                          setEditingResource(id);
                          setAddingResource("url");
                        }}
                        data-button-type="secondary"
                        data-icon-only
                      >
                        <SvgIcon
                          width={20}
                          height={20}
                          src="/img/new-icons/edit-pencil.svg"
                          alt="delete"
                        />
                      </button>

                      <button
                        data-button-type="secondary"
                        onClick={(event) => handleRemove(event, id)}
                        data-icon-only
                      >
                        <SvgIcon
                          width={20}
                          height={20}
                          src="/img/new-icons/red-trash.svg"
                          alt="delete"
                          noFilterOnLight={true}
                        />
                      </button>
                    </div>
                  </article>
                );
              }
            }
          )}
        </section>
      )}

      {addingResource === "none" && (
        <div className="inputs w-full">
          <article
            className="guide-input"
            onClick={() => setAddingResource("pdf")}
          >
            <div className="empty">
              <SvgIcon
                height={20}
                width={20}
                alt=""
                src="/img/new-icons/add.svg"
              />

              <p className="p4">{t("generalResources.uploadPdf")}</p>
            </div>
          </article>
          <article
            className="guide-input"
            onClick={() => setAddingResource("url")}
          >
            <div className="empty">
              <SvgIcon
                height={20}
                width={20}
                alt=""
                src="/img/new-icons/add.svg"
              />

              <p className="p4">{t("generalResources.uploadUrl")}</p>
            </div>
          </article>
        </div>
      )}

      {addingResource === "pdf" && (
        <div className="add-edit-file-wraper">
          <div>
            <FileUpload
              name="resource-pdf"
              prefix=""
              handleFileUpload={handleFileUpload}
              defaultValue={
                !!fileFormState.file ? fileFormState.file : undefined
              }
            />

            <ImageWidgetUploadInput
              name="image"
              prefix=""
              defaultValue={fileFormState.image}
              backgroundedit={`${fileFormState.image.s3Path}`}
              hasImage={!!fileFormState.image}
              handleImageUpload={handleImageUpload}
            />
          </div>
          <div>
            <div>
              <div className="input-box">
                <label>{t("generalResources.fileNameLabel")}</label>
                <input
                  name="name"
                  className="input-videoplaylist-name text-input"
                  placeholder={t("generalResources.fileNamePlaceholder")}
                  value={fileFormState.name}
                  onChange={handleInputFileChange}
                />
              </div>
              <div className="input-box">
                <label>{t("generalResources.descriptionLabel")}</label>
                <input
                  name="description"
                  className="input-videoplaylist-name text-input"
                  value={fileFormState.description}
                  onChange={handleInputFileChange}
                  placeholder={t("generalResources.descriptionPlaceholder")}
                />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <button
                disabled={!validationFileSubmit()}
                data-button-type="primary"
              >
                {t("common:save")}
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setAddingResource("none");
                }}
                data-button-type="text-white"
                data-action="cancel"
              >
                {t("common:cancel")}
              </button>
            </div>
          </div>
        </div>
      )}

      {addingResource === "url" && (
        <div className="add-edit-store-wrapper">
          <ThumbnailUploadInput
            widgetLinkThumbnail={widgetLinkThumbnail}
            name="image"
            backgroundedit={
              linkFormState.thumbnail && !linkFormState.image
                ? linkFormState.thumbnail
                : !linkFormState.thumbnail && linkFormState.image
                  ? S3.toCDN(linkFormState.image.s3Path)
                  : linkFormState.thumbnail && linkFormState.image
                    ? S3.toCDN(linkFormState.image.s3Path)
                    : {}
            }
          />
          <div className="flex flex-col gap-4 ">
            <div className="input-box">
              <label>{t("generalResources.linkUrlLabel")}</label>
              <input
                name="url"
                className="text-input"
                placeholder={t("generalResources.linkUrlPlaceholder")}
                value={linkFormState.url}
                onChange={handleInputLinkChange}
              />
            </div>
            <div className="input-box">
              <label>{t("generalResources.nameLabel")}</label>
              <input
                name="name"
                className="text-input"
                placeholder={t("generalResources.namePlaceholder")}
                value={linkFormState?.name}
                onChange={handleInputLinkChange}
              />
            </div>
            <div className="input-box">
              <label>{t("generalResources.descriptionLabel")}</label>
              <input
                name="description"
                className="text-input"
                placeholder={t("generalResources.descriptionPlaceholder")}
                value={linkFormState?.description}
                onChange={handleInputLinkChange}
              />
            </div>
            <div className="flex flex-row gap-2">
              <button
                data-button-type="primary"
                disabled={!validationLinkSubmit()}
              >
                {t("common:save")}
              </button>
              <button
                data-button-type="text-white"
                data-action="cancel"
                onClick={(e) => {
                  e.preventDefault();
                  setAddingResource("none");
                }}
              >
                {t("common:cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
      <ConfirmationModal
        isOpen={openedConfirmationModal}
        title={t("generalResources.deleteTitle")}
        contentText={t("generalResources.deleteConfirm")}
        cancelButtonText={t("common:cancel")}
        cancelButtonAction={handleCancelDelete}
        confirmButtonText={t("common:delete")}
        confirmButtonAction={handleConfirmDelete}
      />
    </div>
  );
};

export default GeneralResources;
